import './ccss/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ccss/sb-admin-2.min.css';
import './ccss/fontawesome-free/css/all.min.css'
import "datatables.net-dt/css/dataTables.dataTables.min.css"; // Estilos correctos
import "datatables.net-dt"; // Importa DataTables
import Login from './Login';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Registro from './Registro'
import Home from './Home'
import Prehome from './Prehome'
import Trabajadores from './Trabajadores'
import Contratos from './Contratos'
import Compensados from './Compensados'
import Permisos from './Permisos';
import Cotizaciones from './Cotizaciones';
import CotizacionVenta from './CotizacionVenta';
import OrdenCompras from './OrdenCompras';
import Vacaciones from './Vacaciones';
import Colaciones from './Colaciones';
import Administracion from './Administracion';
import Procedimiento from "./prevencion/Procedimiento.js";
import Formatos from './prevencion/Formatos.js';
import Historialtrabajador from './prevencion/Historialtrabajador.js';
import Multimedia from './prevencion/Multimedia.js';
import Faenas from './prevencion/Faenas.js';
import ReglamentoInterno from './prevencion/ReglamentoInterno.js';
import RegistroPrevencion from './prevencion/RegistroPrevencion.js';
import Documentos from './prevencion/Documentos.js';
import Liquidaciones from './Liquidaciones.js';
import Asistencia from './Asistencia.js';
import DashboardAsistencia from './DashboardAsistencia.js';
import Finiquitos from './Finiquitos.js';
import CreacionLiquidaciones from './CreacionLiquidaciones.js';
import CarpetaAdministrativa from './CarpetaAdministrativa.js';
import Inventario from './Inventario.js';
import AsignacionInventario from './AsignacionInventario.js';
import CentroCostos from './CentroCostos.js';
import ProtectedRoute from './Componentes/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Login />}></Route>
        <Route path='/registro' element={<Registro />}></Route>
        <Route path='/home' element={<Home />}></Route>
        <Route path='/Prehome' element={<Prehome />}></Route>
        <Route path='/Login' element={<Login />}></Route>

        {/* Rutas protegidas por permisos de submódulos */}

        {/* Recursos Humanos */}
        <Route path='/Trabajadores' element={
          <ProtectedRoute requiredPermissions={['Trabajadores']}>
            <Trabajadores />
          </ProtectedRoute>
        }></Route>
        <Route path='/Contratos' element={
          <ProtectedRoute requiredPermissions={['Trabajadores']}>
            <Contratos />
          </ProtectedRoute>
        }></Route>
        <Route path='/Compensados' element={
          <ProtectedRoute requiredPermissions={['Compensados']}>
            <Compensados />
          </ProtectedRoute>
        }></Route>
        <Route path='/Permisos' element={
          <ProtectedRoute requiredPermissions={['Permisos']}>
            <Permisos />
          </ProtectedRoute>
        }></Route>
        <Route path='/Vacaciones' element={
          <ProtectedRoute requiredPermissions={['Vacaciones']}>
            <Vacaciones />
          </ProtectedRoute>
        }></Route>
        <Route path='/Colaciones' element={
          <ProtectedRoute requiredPermissions={['Colaciones']}>
            <Colaciones />
          </ProtectedRoute>
        }></Route>
        <Route path='/Liquidaciones' element={
          <ProtectedRoute requiredPermissions={['Liquidaciones']}>
            <Liquidaciones />
          </ProtectedRoute>
        }></Route>
        <Route path='/Asistencia' element={
          <ProtectedRoute requiredPermissions={['Asistencia']}>
            <Asistencia />
          </ProtectedRoute>
        }></Route>
        <Route path='/DashboardAsistencia' element={
          <ProtectedRoute requiredPermissions={['Asistencia']}>
            <DashboardAsistencia />
          </ProtectedRoute>
        }></Route>
        <Route path='/Finiquitos' element={
          <ProtectedRoute requiredPermissions={['Finiquitos']}>
            <Finiquitos />
          </ProtectedRoute>
        }></Route>

        {/* Contabilidad */}
        <Route path='/Cotizaciones' element={
          <ProtectedRoute requiredPermissions={['Cotizaciones']}>
            <Cotizaciones />
          </ProtectedRoute>
        }></Route>
        <Route path='/CotizacionVenta' element={
          <ProtectedRoute requiredPermissions={['Cotizacion Venta']}>
            <CotizacionVenta />
          </ProtectedRoute>
        }></Route>
        <Route path='/OrdenCompras' element={
          <ProtectedRoute requiredPermissions={['Ordenes Compra']}>
            <OrdenCompras />
          </ProtectedRoute>
        }></Route>
        <Route path='/CreacionLiquidaciones' element={
          <ProtectedRoute requiredPermissions={['Liquidaciones']}>
            <CreacionLiquidaciones />
          </ProtectedRoute>
        }></Route>
        <Route path='/CentroCostos' element={
          <ProtectedRoute requiredPermissions={['Centro Costos']}>
            <CentroCostos />
          </ProtectedRoute>
        }></Route>

        {/* Inventario */}
        <Route path='/Inventario' element={
          <ProtectedRoute requiredPermissions={['Gestion Inventario']}>
            <Inventario />
          </ProtectedRoute>
        }></Route>
        <Route path='/AsignacionInventario' element={
          <ProtectedRoute requiredPermissions={['Asignacion Inventario']}>
            <AsignacionInventario />
          </ProtectedRoute>
        }></Route>

        {/* Prevención */}
        <Route path='/prevencion/Procedimiento' element={
          <ProtectedRoute requiredPermissions={['Procedimientos']}>
            <Procedimiento />
          </ProtectedRoute>
        }></Route>
        <Route path='/prevencion/Formatos' element={
          <ProtectedRoute requiredPermissions={['Formatos']}>
            <Formatos />
          </ProtectedRoute>
        }></Route>
        <Route path='/prevencion/Historialtrabajador' element={
          <ProtectedRoute requiredPermissions={['Historial Trabajador']}>
            <Historialtrabajador />
          </ProtectedRoute>
        }></Route>
        <Route path='/prevencion/Multimedia' element={
          <ProtectedRoute requiredPermissions={['Multimedia']}>
            <Multimedia />
          </ProtectedRoute>
        }></Route>
        <Route path='/prevencion/Faenas' element={
          <ProtectedRoute requiredPermissions={['Faenas']}>
            <Faenas />
          </ProtectedRoute>
        }></Route>
        <Route path='/prevencion/RegistroPrevencion' element={
          <ProtectedRoute requiredPermissions={['Registro Prevencion']}>
            <RegistroPrevencion />
          </ProtectedRoute>
        }></Route>
        <Route path='/prevencion/ReglamentoInterno' element={
          <ProtectedRoute requiredPermissions={['Reglamento Interno']}>
            <ReglamentoInterno />
          </ProtectedRoute>
        }></Route>
        <Route path='/prevencion/Documentos' element={
          <ProtectedRoute requiredPermissions={['Documentos']}>
            <Documentos />
          </ProtectedRoute>
        }></Route>

        {/* Administración */}
        <Route path='/Administracion' element={
          <ProtectedRoute requiredPermissions={['Administracion']}>
            <Administracion />
          </ProtectedRoute>
        }></Route>
        <Route path='/CarpetaAdministrativa' element={
          <ProtectedRoute requiredPermissions={['Carpeta Administrativa']}>
            <CarpetaAdministrativa />
          </ProtectedRoute>
        }></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;